import { LIVE_POLL_INTERVAL_MS } from '@/lib/freshness';

/**
 * The live poll interval, behind a seam.
 *
 * The spec fixes it at ten seconds and nothing in the product changes it.
 * The seam exists because the disconnected rung of the freshness ladder is
 * reached by **three consecutive failed polls**, and a test that proves it
 * against a real ten-second interval takes half a minute — long enough that
 * it would end up deleted rather than fixed the first time it flaked.
 */
let intervalMs: number = LIVE_POLL_INTERVAL_MS;

export function livePollIntervalMs(): number {
  return intervalMs;
}

/** Test seam only. Production never calls this. */
export function setLivePollIntervalMs(ms: number): void {
  intervalMs = ms;
}

export function resetLivePollInterval(): void {
  intervalMs = LIVE_POLL_INTERVAL_MS;
}
